import { makeRequest } from 'utils/requestLogger';

export default (id, payload) => makeRequest('put', `/api/recaps/${id}`, payload);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/recap/updateGenieRecap.js